import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ActiveRecordAuditable::AuditAuditableType",
  "collectionKey": "active_record_auditable/audit_auditable_types",
  "collectionName": "audit_auditable_types",
  "i18nKey": "active_record_auditable/audit_auditable_type",
  "camelizedLower": "activeRecordAuditable::AuditAuditableType",
  "name": "AuditAuditableType",
  "nameDasherized": "audit-auditable-type",
  "pluralName": "active_record_auditable_audit_auditable_types",
  "ransackable_associations": [
    {
      "className": "Account::Audit",
      "collectionName": "account_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_audits",
      "macro": "has_many",
      "resource_name": "AccountAudit",
      "through": null
    },
    {
      "className": "AccountSchool::Audit",
      "collectionName": "account_school_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_school_audits",
      "macro": "has_many",
      "resource_name": "AccountSchoolAudit",
      "through": null
    },
    {
      "className": "AccountUser::Audit",
      "collectionName": "account_user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_user_audits",
      "macro": "has_many",
      "resource_name": "AccountUserAudit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "BrainBreak::Audit",
      "collectionName": "brain_break_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "brain_break_audits",
      "macro": "has_many",
      "resource_name": "BrainBreakAudit",
      "through": null
    },
    {
      "className": "BrainBreakClassStep::Audit",
      "collectionName": "brain_break_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "brain_break_class_step_audits",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStepAudit",
      "through": null
    },
    {
      "className": "Challenge::Audit",
      "collectionName": "challenge_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "challenge_audits",
      "macro": "has_many",
      "resource_name": "ChallengeAudit",
      "through": null
    },
    {
      "className": "ChallengeClassStep::Audit",
      "collectionName": "challenge_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "challenge_class_step_audits",
      "macro": "has_many",
      "resource_name": "ChallengeClassStepAudit",
      "through": null
    },
    {
      "className": "CheckIn::Audit",
      "collectionName": "check_in_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "check_in_audits",
      "macro": "has_many",
      "resource_name": "CheckInAudit",
      "through": null
    },
    {
      "className": "CheckInClassStep::Audit",
      "collectionName": "check_in_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "check_in_class_step_audits",
      "macro": "has_many",
      "resource_name": "CheckInClassStepAudit",
      "through": null
    },
    {
      "className": "ClassStatusExpansion::Audit",
      "collectionName": "class_status_expansion_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "class_status_expansion_audits",
      "macro": "has_many",
      "resource_name": "ClassStatusExpansionAudit",
      "through": null
    },
    {
      "className": "ClassStep::Audit",
      "collectionName": "class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "class_step_audits",
      "macro": "has_many",
      "resource_name": "ClassStepAudit",
      "through": null
    },
    {
      "className": "Contact::Audit",
      "collectionName": "contact_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_audits",
      "macro": "has_many",
      "resource_name": "ContactAudit",
      "through": null
    },
    {
      "className": "ContactEmail::Audit",
      "collectionName": "contact_email_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_email_audits",
      "macro": "has_many",
      "resource_name": "ContactEmailAudit",
      "through": null
    },
    {
      "className": "ContactPhoneNumber::Audit",
      "collectionName": "contact_phone_number_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_phone_number_audits",
      "macro": "has_many",
      "resource_name": "ContactPhoneNumberAudit",
      "through": null
    },
    {
      "className": "ContactPoint::Audit",
      "collectionName": "contact_point_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_point_audits",
      "macro": "has_many",
      "resource_name": "ContactPointAudit",
      "through": null
    },
    {
      "className": "ContactRelationship::Audit",
      "collectionName": "contact_relationship_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_relationship_audits",
      "macro": "has_many",
      "resource_name": "ContactRelationshipAudit",
      "through": null
    },
    {
      "className": "ContactRelationshipType::Audit",
      "collectionName": "contact_relationship_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_relationship_type_audits",
      "macro": "has_many",
      "resource_name": "ContactRelationshipTypeAudit",
      "through": null
    },
    {
      "className": "ContactType::Audit",
      "collectionName": "contact_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_type_audits",
      "macro": "has_many",
      "resource_name": "ContactTypeAudit",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer::Audit",
      "collectionName": "content_absolute_container_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_absolute_container_audits",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainerAudit",
      "through": null
    },
    {
      "className": "Content::Audit",
      "collectionName": "content_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_audits",
      "macro": "has_many",
      "resource_name": "ContentAudit",
      "through": null
    },
    {
      "className": "ContentPieceType::Audit",
      "collectionName": "content_piece_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_piece_type_audits",
      "macro": "has_many",
      "resource_name": "ContentPieceTypeAudit",
      "through": null
    },
    {
      "className": "Country::Audit",
      "collectionName": "country_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "country_audits",
      "macro": "has_many",
      "resource_name": "CountryAudit",
      "through": null
    },
    {
      "className": "CountryState::Audit",
      "collectionName": "country_state_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "country_state_audits",
      "macro": "has_many",
      "resource_name": "CountryStateAudit",
      "through": null
    },
    {
      "className": "Course::Audit",
      "collectionName": "course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_audits",
      "macro": "has_many",
      "resource_name": "CourseAudit",
      "through": null
    },
    {
      "className": "CourseClassStep::Audit",
      "collectionName": "course_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_class_step_audits",
      "macro": "has_many",
      "resource_name": "CourseClassStepAudit",
      "through": null
    },
    {
      "className": "CourseGroup::Audit",
      "collectionName": "course_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_group_audits",
      "macro": "has_many",
      "resource_name": "CourseGroupAudit",
      "through": null
    },
    {
      "className": "CourseGroupCourse::Audit",
      "collectionName": "course_group_course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_group_course_audits",
      "macro": "has_many",
      "resource_name": "CourseGroupCourseAudit",
      "through": null
    },
    {
      "className": "CourseModule::Audit",
      "collectionName": "course_module_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_module_audits",
      "macro": "has_many",
      "resource_name": "CourseModuleAudit",
      "through": null
    },
    {
      "className": "Currency::Audit",
      "collectionName": "currency_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "currency_audits",
      "macro": "has_many",
      "resource_name": "CurrencyAudit",
      "through": null
    },
    {
      "className": "Dialogue::Audit",
      "collectionName": "dialogue_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "dialogue_audits",
      "macro": "has_many",
      "resource_name": "DialogueAudit",
      "through": null
    },
    {
      "className": "EmailTemplate::Audit",
      "collectionName": "email_template_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplateAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreview::Audit",
      "collectionName": "email_template_preview_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_preview_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreviewLiquidVariable::Audit",
      "collectionName": "email_template_preview_liquid_variable_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_preview_liquid_variable_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewLiquidVariableAudit",
      "through": null
    },
    {
      "className": "Invoice::Audit",
      "collectionName": "invoice_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_audits",
      "macro": "has_many",
      "resource_name": "InvoiceAudit",
      "through": null
    },
    {
      "className": "InvoiceInfo::Audit",
      "collectionName": "invoice_info_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_info_audits",
      "macro": "has_many",
      "resource_name": "InvoiceInfoAudit",
      "through": null
    },
    {
      "className": "InvoiceLine::Audit",
      "collectionName": "invoice_line_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_line_audits",
      "macro": "has_many",
      "resource_name": "InvoiceLineAudit",
      "through": null
    },
    {
      "className": "Locale::Audit",
      "collectionName": "locale_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "locale_audits",
      "macro": "has_many",
      "resource_name": "LocaleAudit",
      "through": null
    },
    {
      "className": "Newsletter::Audit",
      "collectionName": "newsletter_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_audits",
      "macro": "has_many",
      "resource_name": "NewsletterAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplate::Audit",
      "collectionName": "newsletter_template_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplateTableSearch::Audit",
      "collectionName": "newsletter_template_table_search_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_table_search_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTableSearchAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplateTimeZoneState::Audit",
      "collectionName": "newsletter_template_time_zone_state_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_time_zone_state_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTimeZoneStateAudit",
      "through": null
    },
    {
      "className": "Notification::Audit",
      "collectionName": "notification_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_audits",
      "macro": "has_many",
      "resource_name": "NotificationAudit",
      "through": null
    },
    {
      "className": "NotificationSetting::Audit",
      "collectionName": "notification_setting_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_setting_audits",
      "macro": "has_many",
      "resource_name": "NotificationSettingAudit",
      "through": null
    },
    {
      "className": "NotificationTypeAction::Audit",
      "collectionName": "notification_type_action_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_action_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeActionAudit",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger::Audit",
      "collectionName": "notification_type_audit_trigger_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_audit_trigger_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAuditTriggerAudit",
      "through": null
    },
    {
      "className": "NotificationType::Audit",
      "collectionName": "notification_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAudit",
      "through": null
    },
    {
      "className": "PageContent::Audit",
      "collectionName": "page_content_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "page_content_audits",
      "macro": "has_many",
      "resource_name": "PageContentAudit",
      "through": null
    },
    {
      "className": "PageView::Audit",
      "collectionName": "page_view_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "page_view_audits",
      "macro": "has_many",
      "resource_name": "PageViewAudit",
      "through": null
    },
    {
      "className": "PaymentMethod::Audit",
      "collectionName": "payment_method_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "payment_method_audits",
      "macro": "has_many",
      "resource_name": "PaymentMethodAudit",
      "through": null
    },
    {
      "className": "Plan::Audit",
      "collectionName": "plan_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_audits",
      "macro": "has_many",
      "resource_name": "PlanAudit",
      "through": null
    },
    {
      "className": "PlanResource::Audit",
      "collectionName": "plan_resource_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_audits",
      "macro": "has_many",
      "resource_name": "PlanResourceAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriod::Audit",
      "collectionName": "plan_resource_period_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_period_audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriodPrice::Audit",
      "collectionName": "plan_resource_period_price_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_period_price_audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodPriceAudit",
      "through": null
    },
    {
      "className": "Role::Audit",
      "collectionName": "role_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "role_audits",
      "macro": "has_many",
      "resource_name": "RoleAudit",
      "through": null
    },
    {
      "className": "School::Audit",
      "collectionName": "school_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_audits",
      "macro": "has_many",
      "resource_name": "SchoolAudit",
      "through": null
    },
    {
      "className": "SchoolClass::Audit",
      "collectionName": "school_class_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassAudit",
      "through": null
    },
    {
      "className": "SchoolClassBrainBreak::Audit",
      "collectionName": "school_class_brain_break_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_brain_break_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassBrainBreakAudit",
      "through": null
    },
    {
      "className": "SchoolClassChallenge::Audit",
      "collectionName": "school_class_challenge_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_challenge_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassChallengeAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn::Audit",
      "collectionName": "school_class_check_in_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_check_in_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckInEvent::Audit",
      "collectionName": "school_class_check_in_event_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_check_in_event_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInEventAudit",
      "through": null
    },
    {
      "className": "SchoolClassContentPiece::Audit",
      "collectionName": "school_class_content_piece_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_content_piece_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassContentPieceAudit",
      "through": null
    },
    {
      "className": "SchoolClassCourse::Audit",
      "collectionName": "school_class_course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_course_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseAudit",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule::Audit",
      "collectionName": "school_class_course_module_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_course_module_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModuleAudit",
      "through": null
    },
    {
      "className": "SchoolClassGroup::Audit",
      "collectionName": "school_class_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_group_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupAudit",
      "through": null
    },
    {
      "className": "SchoolClassGroupClassStep::Audit",
      "collectionName": "school_class_group_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_group_class_step_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupClassStepAudit",
      "through": null
    },
    {
      "className": "SchoolClassInvitation::Audit",
      "collectionName": "school_class_invitation_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_invitation_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitationAudit",
      "through": null
    },
    {
      "className": "SchoolContactRequest::Audit",
      "collectionName": "school_contact_request_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_contact_request_audits",
      "macro": "has_many",
      "resource_name": "SchoolContactRequestAudit",
      "through": null
    },
    {
      "className": "ScoreFactor::Audit",
      "collectionName": "score_factor_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorAudit",
      "through": null
    },
    {
      "className": "ScoreFactorGroup::Audit",
      "collectionName": "score_factor_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_group_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupAudit",
      "through": null
    },
    {
      "className": "ScoreFactorGroupScoreFactor::Audit",
      "collectionName": "score_factor_group_score_factor_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_group_score_factor_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupScoreFactorAudit",
      "through": null
    },
    {
      "className": "Styling::Audit",
      "collectionName": "styling_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "styling_audits",
      "macro": "has_many",
      "resource_name": "StylingAudit",
      "through": null
    },
    {
      "className": "Subscription::Audit",
      "collectionName": "subscription_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "subscription_audits",
      "macro": "has_many",
      "resource_name": "SubscriptionAudit",
      "through": null
    },
    {
      "className": "SubscriptionPeriod::Audit",
      "collectionName": "subscription_period_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "subscription_period_audits",
      "macro": "has_many",
      "resource_name": "SubscriptionPeriodAudit",
      "through": null
    },
    {
      "className": "Survey::Audit",
      "collectionName": "survey_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_audits",
      "macro": "has_many",
      "resource_name": "SurveyAudit",
      "through": null
    },
    {
      "className": "SurveyStep::Audit",
      "collectionName": "survey_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepAudit",
      "through": null
    },
    {
      "className": "SurveyStepElement::Audit",
      "collectionName": "survey_step_element_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOption::Audit",
      "collectionName": "survey_step_element_option_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_option_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOptionScore::Audit",
      "collectionName": "survey_step_element_option_score_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_option_score_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionScoreAudit",
      "through": null
    },
    {
      "className": "Team::Audit",
      "collectionName": "team_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_audits",
      "macro": "has_many",
      "resource_name": "TeamAudit",
      "through": null
    },
    {
      "className": "TeamSurvey::Audit",
      "collectionName": "team_survey_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStep::Audit",
      "collectionName": "team_survey_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStepElementAnswer::Audit",
      "collectionName": "team_survey_step_element_answer_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_element_answer_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswerAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement::Audit",
      "collectionName": "team_survey_step_element_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_element_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAudit",
      "through": null
    },
    {
      "className": "TeamUser::Audit",
      "collectionName": "team_user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_user_audits",
      "macro": "has_many",
      "resource_name": "TeamUserAudit",
      "through": null
    },
    {
      "className": "TextKey::Audit",
      "collectionName": "text_key_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "text_key_audits",
      "macro": "has_many",
      "resource_name": "TextKeyAudit",
      "through": null
    },
    {
      "className": "TextValue::Audit",
      "collectionName": "text_value_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "text_value_audits",
      "macro": "has_many",
      "resource_name": "TextValueAudit",
      "through": null
    },
    {
      "className": "Translation::Audit",
      "collectionName": "translation_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "translation_audits",
      "macro": "has_many",
      "resource_name": "TranslationAudit",
      "through": null
    },
    {
      "className": "TrixFile::Audit",
      "collectionName": "trix_file_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "trix_file_audits",
      "macro": "has_many",
      "resource_name": "TrixFileAudit",
      "through": null
    },
    {
      "className": "User::Audit",
      "collectionName": "user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "user_audits",
      "macro": "has_many",
      "resource_name": "UserAudit",
      "through": null
    },
    {
      "className": "UserRole::Audit",
      "collectionName": "user_role_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "user_role_audits",
      "macro": "has_many",
      "resource_name": "UserRoleAudit",
      "through": null
    },
    {
      "className": "VatNumber::Audit",
      "collectionName": "vat_number_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "vat_number_audits",
      "macro": "has_many",
      "resource_name": "VatNumberAudit",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "Account::Audit",
      "collectionName": "account_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_audits",
      "macro": "has_many",
      "resource_name": "AccountAudit",
      "through": null
    },
    {
      "className": "AccountSchool::Audit",
      "collectionName": "account_school_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_school_audits",
      "macro": "has_many",
      "resource_name": "AccountSchoolAudit",
      "through": null
    },
    {
      "className": "AccountUser::Audit",
      "collectionName": "account_user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "account_user_audits",
      "macro": "has_many",
      "resource_name": "AccountUserAudit",
      "through": null
    },
    {
      "className": "BrainBreak::Audit",
      "collectionName": "brain_break_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "brain_break_audits",
      "macro": "has_many",
      "resource_name": "BrainBreakAudit",
      "through": null
    },
    {
      "className": "BrainBreakClassStep::Audit",
      "collectionName": "brain_break_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "brain_break_class_step_audits",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStepAudit",
      "through": null
    },
    {
      "className": "Challenge::Audit",
      "collectionName": "challenge_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "challenge_audits",
      "macro": "has_many",
      "resource_name": "ChallengeAudit",
      "through": null
    },
    {
      "className": "ChallengeClassStep::Audit",
      "collectionName": "challenge_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "challenge_class_step_audits",
      "macro": "has_many",
      "resource_name": "ChallengeClassStepAudit",
      "through": null
    },
    {
      "className": "CheckIn::Audit",
      "collectionName": "check_in_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "check_in_audits",
      "macro": "has_many",
      "resource_name": "CheckInAudit",
      "through": null
    },
    {
      "className": "CheckInClassStep::Audit",
      "collectionName": "check_in_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "check_in_class_step_audits",
      "macro": "has_many",
      "resource_name": "CheckInClassStepAudit",
      "through": null
    },
    {
      "className": "ClassStatusExpansion::Audit",
      "collectionName": "class_status_expansion_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "class_status_expansion_audits",
      "macro": "has_many",
      "resource_name": "ClassStatusExpansionAudit",
      "through": null
    },
    {
      "className": "ClassStep::Audit",
      "collectionName": "class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "class_step_audits",
      "macro": "has_many",
      "resource_name": "ClassStepAudit",
      "through": null
    },
    {
      "className": "Contact::Audit",
      "collectionName": "contact_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_audits",
      "macro": "has_many",
      "resource_name": "ContactAudit",
      "through": null
    },
    {
      "className": "ContactEmail::Audit",
      "collectionName": "contact_email_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_email_audits",
      "macro": "has_many",
      "resource_name": "ContactEmailAudit",
      "through": null
    },
    {
      "className": "ContactPhoneNumber::Audit",
      "collectionName": "contact_phone_number_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_phone_number_audits",
      "macro": "has_many",
      "resource_name": "ContactPhoneNumberAudit",
      "through": null
    },
    {
      "className": "ContactPoint::Audit",
      "collectionName": "contact_point_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_point_audits",
      "macro": "has_many",
      "resource_name": "ContactPointAudit",
      "through": null
    },
    {
      "className": "ContactRelationship::Audit",
      "collectionName": "contact_relationship_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_relationship_audits",
      "macro": "has_many",
      "resource_name": "ContactRelationshipAudit",
      "through": null
    },
    {
      "className": "ContactRelationshipType::Audit",
      "collectionName": "contact_relationship_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_relationship_type_audits",
      "macro": "has_many",
      "resource_name": "ContactRelationshipTypeAudit",
      "through": null
    },
    {
      "className": "ContactType::Audit",
      "collectionName": "contact_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "contact_type_audits",
      "macro": "has_many",
      "resource_name": "ContactTypeAudit",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer::Audit",
      "collectionName": "content_absolute_container_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_absolute_container_audits",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainerAudit",
      "through": null
    },
    {
      "className": "Content::Audit",
      "collectionName": "content_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_audits",
      "macro": "has_many",
      "resource_name": "ContentAudit",
      "through": null
    },
    {
      "className": "ContentPieceType::Audit",
      "collectionName": "content_piece_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "content_piece_type_audits",
      "macro": "has_many",
      "resource_name": "ContentPieceTypeAudit",
      "through": null
    },
    {
      "className": "Country::Audit",
      "collectionName": "country_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "country_audits",
      "macro": "has_many",
      "resource_name": "CountryAudit",
      "through": null
    },
    {
      "className": "CountryState::Audit",
      "collectionName": "country_state_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "country_state_audits",
      "macro": "has_many",
      "resource_name": "CountryStateAudit",
      "through": null
    },
    {
      "className": "Course::Audit",
      "collectionName": "course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_audits",
      "macro": "has_many",
      "resource_name": "CourseAudit",
      "through": null
    },
    {
      "className": "CourseClassStep::Audit",
      "collectionName": "course_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_class_step_audits",
      "macro": "has_many",
      "resource_name": "CourseClassStepAudit",
      "through": null
    },
    {
      "className": "CourseGroup::Audit",
      "collectionName": "course_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_group_audits",
      "macro": "has_many",
      "resource_name": "CourseGroupAudit",
      "through": null
    },
    {
      "className": "CourseGroupCourse::Audit",
      "collectionName": "course_group_course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_group_course_audits",
      "macro": "has_many",
      "resource_name": "CourseGroupCourseAudit",
      "through": null
    },
    {
      "className": "CourseModule::Audit",
      "collectionName": "course_module_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "course_module_audits",
      "macro": "has_many",
      "resource_name": "CourseModuleAudit",
      "through": null
    },
    {
      "className": "Currency::Audit",
      "collectionName": "currency_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "currency_audits",
      "macro": "has_many",
      "resource_name": "CurrencyAudit",
      "through": null
    },
    {
      "className": "Dialogue::Audit",
      "collectionName": "dialogue_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "dialogue_audits",
      "macro": "has_many",
      "resource_name": "DialogueAudit",
      "through": null
    },
    {
      "className": "EmailTemplate::Audit",
      "collectionName": "email_template_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplateAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreview::Audit",
      "collectionName": "email_template_preview_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_preview_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreviewLiquidVariable::Audit",
      "collectionName": "email_template_preview_liquid_variable_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "email_template_preview_liquid_variable_audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewLiquidVariableAudit",
      "through": null
    },
    {
      "className": "Invoice::Audit",
      "collectionName": "invoice_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_audits",
      "macro": "has_many",
      "resource_name": "InvoiceAudit",
      "through": null
    },
    {
      "className": "InvoiceInfo::Audit",
      "collectionName": "invoice_info_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_info_audits",
      "macro": "has_many",
      "resource_name": "InvoiceInfoAudit",
      "through": null
    },
    {
      "className": "InvoiceLine::Audit",
      "collectionName": "invoice_line_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "invoice_line_audits",
      "macro": "has_many",
      "resource_name": "InvoiceLineAudit",
      "through": null
    },
    {
      "className": "Locale::Audit",
      "collectionName": "locale_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "locale_audits",
      "macro": "has_many",
      "resource_name": "LocaleAudit",
      "through": null
    },
    {
      "className": "Newsletter::Audit",
      "collectionName": "newsletter_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_audits",
      "macro": "has_many",
      "resource_name": "NewsletterAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplate::Audit",
      "collectionName": "newsletter_template_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplateTableSearch::Audit",
      "collectionName": "newsletter_template_table_search_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_table_search_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTableSearchAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplateTimeZoneState::Audit",
      "collectionName": "newsletter_template_time_zone_state_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "newsletter_template_time_zone_state_audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTimeZoneStateAudit",
      "through": null
    },
    {
      "className": "Notification::Audit",
      "collectionName": "notification_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_audits",
      "macro": "has_many",
      "resource_name": "NotificationAudit",
      "through": null
    },
    {
      "className": "NotificationSetting::Audit",
      "collectionName": "notification_setting_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_setting_audits",
      "macro": "has_many",
      "resource_name": "NotificationSettingAudit",
      "through": null
    },
    {
      "className": "NotificationTypeAction::Audit",
      "collectionName": "notification_type_action_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_action_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeActionAudit",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger::Audit",
      "collectionName": "notification_type_audit_trigger_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_audit_trigger_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAuditTriggerAudit",
      "through": null
    },
    {
      "className": "NotificationType::Audit",
      "collectionName": "notification_type_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "notification_type_audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAudit",
      "through": null
    },
    {
      "className": "PageContent::Audit",
      "collectionName": "page_content_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "page_content_audits",
      "macro": "has_many",
      "resource_name": "PageContentAudit",
      "through": null
    },
    {
      "className": "PageView::Audit",
      "collectionName": "page_view_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "page_view_audits",
      "macro": "has_many",
      "resource_name": "PageViewAudit",
      "through": null
    },
    {
      "className": "PaymentMethod::Audit",
      "collectionName": "payment_method_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "payment_method_audits",
      "macro": "has_many",
      "resource_name": "PaymentMethodAudit",
      "through": null
    },
    {
      "className": "Plan::Audit",
      "collectionName": "plan_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_audits",
      "macro": "has_many",
      "resource_name": "PlanAudit",
      "through": null
    },
    {
      "className": "PlanResource::Audit",
      "collectionName": "plan_resource_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_audits",
      "macro": "has_many",
      "resource_name": "PlanResourceAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriod::Audit",
      "collectionName": "plan_resource_period_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_period_audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriodPrice::Audit",
      "collectionName": "plan_resource_period_price_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "plan_resource_period_price_audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodPriceAudit",
      "through": null
    },
    {
      "className": "Role::Audit",
      "collectionName": "role_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "role_audits",
      "macro": "has_many",
      "resource_name": "RoleAudit",
      "through": null
    },
    {
      "className": "School::Audit",
      "collectionName": "school_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_audits",
      "macro": "has_many",
      "resource_name": "SchoolAudit",
      "through": null
    },
    {
      "className": "SchoolClass::Audit",
      "collectionName": "school_class_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn::Audit",
      "collectionName": "school_class_check_in_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_check_in_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckInEvent::Audit",
      "collectionName": "school_class_check_in_event_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_check_in_event_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInEventAudit",
      "through": null
    },
    {
      "className": "SchoolClassContentPiece::Audit",
      "collectionName": "school_class_content_piece_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_content_piece_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassContentPieceAudit",
      "through": null
    },
    {
      "className": "SchoolClassCourse::Audit",
      "collectionName": "school_class_course_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_course_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseAudit",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule::Audit",
      "collectionName": "school_class_course_module_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_course_module_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModuleAudit",
      "through": null
    },
    {
      "className": "SchoolClassGroup::Audit",
      "collectionName": "school_class_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_group_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupAudit",
      "through": null
    },
    {
      "className": "SchoolClassGroupClassStep::Audit",
      "collectionName": "school_class_group_class_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_group_class_step_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupClassStepAudit",
      "through": null
    },
    {
      "className": "SchoolClassInvitation::Audit",
      "collectionName": "school_class_invitation_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_class_invitation_audits",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitationAudit",
      "through": null
    },
    {
      "className": "SchoolContactRequest::Audit",
      "collectionName": "school_contact_request_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "school_contact_request_audits",
      "macro": "has_many",
      "resource_name": "SchoolContactRequestAudit",
      "through": null
    },
    {
      "className": "ScoreFactor::Audit",
      "collectionName": "score_factor_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorAudit",
      "through": null
    },
    {
      "className": "ScoreFactorGroup::Audit",
      "collectionName": "score_factor_group_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_group_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupAudit",
      "through": null
    },
    {
      "className": "ScoreFactorGroupScoreFactor::Audit",
      "collectionName": "score_factor_group_score_factor_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "score_factor_group_score_factor_audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupScoreFactorAudit",
      "through": null
    },
    {
      "className": "Styling::Audit",
      "collectionName": "styling_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "styling_audits",
      "macro": "has_many",
      "resource_name": "StylingAudit",
      "through": null
    },
    {
      "className": "Subscription::Audit",
      "collectionName": "subscription_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "subscription_audits",
      "macro": "has_many",
      "resource_name": "SubscriptionAudit",
      "through": null
    },
    {
      "className": "SubscriptionPeriod::Audit",
      "collectionName": "subscription_period_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "subscription_period_audits",
      "macro": "has_many",
      "resource_name": "SubscriptionPeriodAudit",
      "through": null
    },
    {
      "className": "Survey::Audit",
      "collectionName": "survey_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_audits",
      "macro": "has_many",
      "resource_name": "SurveyAudit",
      "through": null
    },
    {
      "className": "SurveyStep::Audit",
      "collectionName": "survey_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepAudit",
      "through": null
    },
    {
      "className": "SurveyStepElement::Audit",
      "collectionName": "survey_step_element_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOption::Audit",
      "collectionName": "survey_step_element_option_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_option_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOptionScore::Audit",
      "collectionName": "survey_step_element_option_score_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "survey_step_element_option_score_audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionScoreAudit",
      "through": null
    },
    {
      "className": "Team::Audit",
      "collectionName": "team_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_audits",
      "macro": "has_many",
      "resource_name": "TeamAudit",
      "through": null
    },
    {
      "className": "TeamSurvey::Audit",
      "collectionName": "team_survey_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStep::Audit",
      "collectionName": "team_survey_step_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStepElementAnswer::Audit",
      "collectionName": "team_survey_step_element_answer_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_element_answer_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswerAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement::Audit",
      "collectionName": "team_survey_step_element_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_survey_step_element_audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAudit",
      "through": null
    },
    {
      "className": "TeamUser::Audit",
      "collectionName": "team_user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "team_user_audits",
      "macro": "has_many",
      "resource_name": "TeamUserAudit",
      "through": null
    },
    {
      "className": "TextKey::Audit",
      "collectionName": "text_key_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "text_key_audits",
      "macro": "has_many",
      "resource_name": "TextKeyAudit",
      "through": null
    },
    {
      "className": "TextValue::Audit",
      "collectionName": "text_value_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "text_value_audits",
      "macro": "has_many",
      "resource_name": "TextValueAudit",
      "through": null
    },
    {
      "className": "Translation::Audit",
      "collectionName": "translation_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "translation_audits",
      "macro": "has_many",
      "resource_name": "TranslationAudit",
      "through": null
    },
    {
      "className": "TrixFile::Audit",
      "collectionName": "trix_file_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "trix_file_audits",
      "macro": "has_many",
      "resource_name": "TrixFileAudit",
      "through": null
    },
    {
      "className": "User::Audit",
      "collectionName": "user_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "user_audits",
      "macro": "has_many",
      "resource_name": "UserAudit",
      "through": null
    },
    {
      "className": "UserRole::Audit",
      "collectionName": "user_role_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "user_role_audits",
      "macro": "has_many",
      "resource_name": "UserRoleAudit",
      "through": null
    },
    {
      "className": "VatNumber::Audit",
      "collectionName": "vat_number_audits",
      "foreignKey": "audit_auditable_type_id",
      "name": "vat_number_audits",
      "macro": "has_many",
      "resource_name": "VatNumberAudit",
      "through": null
    }
  ],
  "paramKey": "audit_auditable_type",
  "primaryKey": "id"
}

/** Frontend model for AuditAuditableType. */
class AuditAuditableType extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./audit.js").default>} */
  audits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("Audit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "audits",
        model: this,
        modelName: "ActiveRecordAuditable::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./audit.js").default>>} */
  loadAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("Audit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./account-audit.js").default>} */
  accountAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "account_audits",
        model: this,
        modelName: "Account::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./account-audit.js").default>>} */
  loadAccountAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "account_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./account-school-audit.js").default>} */
  accountSchoolAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountSchoolAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "account_school_audits",
        model: this,
        modelName: "AccountSchool::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./account-school-audit.js").default>>} */
  loadAccountSchoolAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountSchoolAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "account_school_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./account-user-audit.js").default>} */
  accountUserAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountUserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "account_user_audits",
        model: this,
        modelName: "AccountUser::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./account-user-audit.js").default>>} */
  loadAccountUserAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("AccountUserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "account_user_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./brain-break-audit.js").default>} */
  brainBreakAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "brain_break_audits",
        model: this,
        modelName: "BrainBreak::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./brain-break-audit.js").default>>} */
  loadBrainBreakAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "brain_break_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./brain-break-class-step-audit.js").default>} */
  brainBreakClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "brain_break_class_step_audits",
        model: this,
        modelName: "BrainBreakClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./brain-break-class-step-audit.js").default>>} */
  loadBrainBreakClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "brain_break_class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./challenge-audit.js").default>} */
  challengeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ChallengeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "challenge_audits",
        model: this,
        modelName: "Challenge::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./challenge-audit.js").default>>} */
  loadChallengeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ChallengeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "challenge_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./challenge-class-step-audit.js").default>} */
  challengeClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ChallengeClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "challenge_class_step_audits",
        model: this,
        modelName: "ChallengeClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./challenge-class-step-audit.js").default>>} */
  loadChallengeClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ChallengeClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "challenge_class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./check-in-audit.js").default>} */
  checkInAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CheckInAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "check_in_audits",
        model: this,
        modelName: "CheckIn::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./check-in-audit.js").default>>} */
  loadCheckInAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CheckInAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "check_in_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./check-in-class-step-audit.js").default>} */
  checkInClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CheckInClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "check_in_class_step_audits",
        model: this,
        modelName: "CheckInClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./check-in-class-step-audit.js").default>>} */
  loadCheckInClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CheckInClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "check_in_class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-status-expansion-audit.js").default>} */
  classStatusExpansionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ClassStatusExpansionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "class_status_expansion_audits",
        model: this,
        modelName: "ClassStatusExpansion::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./class-status-expansion-audit.js").default>>} */
  loadClassStatusExpansionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ClassStatusExpansionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "class_status_expansion_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step-audit.js").default>} */
  classStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "class_step_audits",
        model: this,
        modelName: "ClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./class-step-audit.js").default>>} */
  loadClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-audit.js").default>} */
  contactAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_audits",
        model: this,
        modelName: "Contact::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-audit.js").default>>} */
  loadContactAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-email-audit.js").default>} */
  contactEmailAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactEmailAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_email_audits",
        model: this,
        modelName: "ContactEmail::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-email-audit.js").default>>} */
  loadContactEmailAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactEmailAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_email_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-phone-number-audit.js").default>} */
  contactPhoneNumberAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactPhoneNumberAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_phone_number_audits",
        model: this,
        modelName: "ContactPhoneNumber::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-phone-number-audit.js").default>>} */
  loadContactPhoneNumberAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactPhoneNumberAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_phone_number_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-point-audit.js").default>} */
  contactPointAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactPointAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_point_audits",
        model: this,
        modelName: "ContactPoint::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-point-audit.js").default>>} */
  loadContactPointAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactPointAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_point_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship-audit.js").default>} */
  contactRelationshipAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactRelationshipAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_relationship_audits",
        model: this,
        modelName: "ContactRelationship::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship-audit.js").default>>} */
  loadContactRelationshipAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactRelationshipAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_relationship_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship-type-audit.js").default>} */
  contactRelationshipTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactRelationshipTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_relationship_type_audits",
        model: this,
        modelName: "ContactRelationshipType::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship-type-audit.js").default>>} */
  loadContactRelationshipTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactRelationshipTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_relationship_type_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-type-audit.js").default>} */
  contactTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_type_audits",
        model: this,
        modelName: "ContactType::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-type-audit.js").default>>} */
  loadContactTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContactTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_type_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content-absolute-container-audit.js").default>} */
  contentAbsoluteContainerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAbsoluteContainerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "content_absolute_container_audits",
        model: this,
        modelName: "ContentAbsoluteContainer::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content-absolute-container-audit.js").default>>} */
  loadContentAbsoluteContainerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAbsoluteContainerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "content_absolute_container_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content-audit.js").default>} */
  contentAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "content_audits",
        model: this,
        modelName: "Content::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content-audit.js").default>>} */
  loadContentAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "content_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content-piece-type-audit.js").default>} */
  contentPieceTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentPieceTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "content_piece_type_audits",
        model: this,
        modelName: "ContentPieceType::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content-piece-type-audit.js").default>>} */
  loadContentPieceTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentPieceTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "content_piece_type_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./country-audit.js").default>} */
  countryAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CountryAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "country_audits",
        model: this,
        modelName: "Country::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./country-audit.js").default>>} */
  loadCountryAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CountryAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "country_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./country-state-audit.js").default>} */
  countryStateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CountryStateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "country_state_audits",
        model: this,
        modelName: "CountryState::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./country-state-audit.js").default>>} */
  loadCountryStateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CountryStateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "country_state_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-audit.js").default>} */
  courseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_audits",
        model: this,
        modelName: "Course::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-audit.js").default>>} */
  loadCourseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-class-step-audit.js").default>} */
  courseClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_class_step_audits",
        model: this,
        modelName: "CourseClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-class-step-audit.js").default>>} */
  loadCourseClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-group-audit.js").default>} */
  courseGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_group_audits",
        model: this,
        modelName: "CourseGroup::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-group-audit.js").default>>} */
  loadCourseGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_group_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-group-course-audit.js").default>} */
  courseGroupCourseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupCourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_group_course_audits",
        model: this,
        modelName: "CourseGroupCourse::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-group-course-audit.js").default>>} */
  loadCourseGroupCourseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseGroupCourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_group_course_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-module-audit.js").default>} */
  courseModuleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseModuleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_module_audits",
        model: this,
        modelName: "CourseModule::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-module-audit.js").default>>} */
  loadCourseModuleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CourseModuleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_module_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./currency-audit.js").default>} */
  currencyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CurrencyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "currency_audits",
        model: this,
        modelName: "Currency::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./currency-audit.js").default>>} */
  loadCurrencyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("CurrencyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "currency_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./dialogue-audit.js").default>} */
  dialogueAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("DialogueAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "dialogue_audits",
        model: this,
        modelName: "Dialogue::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./dialogue-audit.js").default>>} */
  loadDialogueAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("DialogueAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "dialogue_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./email-template-audit.js").default>} */
  emailTemplateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "email_template_audits",
        model: this,
        modelName: "EmailTemplate::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email-template-audit.js").default>>} */
  loadEmailTemplateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "email_template_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./email-template-preview-audit.js").default>} */
  emailTemplatePreviewAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "email_template_preview_audits",
        model: this,
        modelName: "EmailTemplatePreview::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email-template-preview-audit.js").default>>} */
  loadEmailTemplatePreviewAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "email_template_preview_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./email-template-preview-liquid-variable-audit.js").default>} */
  emailTemplatePreviewLiquidVariableAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewLiquidVariableAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "email_template_preview_liquid_variable_audits",
        model: this,
        modelName: "EmailTemplatePreviewLiquidVariable::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email-template-preview-liquid-variable-audit.js").default>>} */
  loadEmailTemplatePreviewLiquidVariableAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewLiquidVariableAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "email_template_preview_liquid_variable_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./invoice-audit.js").default>} */
  invoiceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "invoice_audits",
        model: this,
        modelName: "Invoice::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-audit.js").default>>} */
  loadInvoiceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "invoice_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./invoice-info-audit.js").default>} */
  invoiceInfoAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceInfoAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "invoice_info_audits",
        model: this,
        modelName: "InvoiceInfo::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-info-audit.js").default>>} */
  loadInvoiceInfoAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceInfoAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "invoice_info_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./invoice-line-audit.js").default>} */
  invoiceLineAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceLineAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "invoice_line_audits",
        model: this,
        modelName: "InvoiceLine::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-line-audit.js").default>>} */
  loadInvoiceLineAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceLineAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "invoice_line_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./locale-audit.js").default>} */
  localeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("LocaleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "locale_audits",
        model: this,
        modelName: "Locale::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./locale-audit.js").default>>} */
  loadLocaleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("LocaleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "locale_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./newsletter-audit.js").default>} */
  newsletterAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "newsletter_audits",
        model: this,
        modelName: "Newsletter::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./newsletter-audit.js").default>>} */
  loadNewsletterAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "newsletter_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./newsletter-template-audit.js").default>} */
  newsletterTemplateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "newsletter_template_audits",
        model: this,
        modelName: "NewsletterTemplate::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./newsletter-template-audit.js").default>>} */
  loadNewsletterTemplateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "newsletter_template_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./newsletter-template-table-search-audit.js").default>} */
  newsletterTemplateTableSearchAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateTableSearchAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "newsletter_template_table_search_audits",
        model: this,
        modelName: "NewsletterTemplateTableSearch::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./newsletter-template-table-search-audit.js").default>>} */
  loadNewsletterTemplateTableSearchAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateTableSearchAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "newsletter_template_table_search_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./newsletter-template-time-zone-state-audit.js").default>} */
  newsletterTemplateTimeZoneStateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateTimeZoneStateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "newsletter_template_time_zone_state_audits",
        model: this,
        modelName: "NewsletterTemplateTimeZoneState::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./newsletter-template-time-zone-state-audit.js").default>>} */
  loadNewsletterTemplateTimeZoneStateAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NewsletterTemplateTimeZoneStateAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "newsletter_template_time_zone_state_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-audit.js").default>} */
  notificationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "notification_audits",
        model: this,
        modelName: "Notification::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-audit.js").default>>} */
  loadNotificationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "notification_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-setting-audit.js").default>} */
  notificationSettingAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationSettingAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "notification_setting_audits",
        model: this,
        modelName: "NotificationSetting::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-setting-audit.js").default>>} */
  loadNotificationSettingAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationSettingAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "notification_setting_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-type-action-audit.js").default>} */
  notificationTypeActionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeActionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "notification_type_action_audits",
        model: this,
        modelName: "NotificationTypeAction::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-type-action-audit.js").default>>} */
  loadNotificationTypeActionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeActionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "notification_type_action_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-type-audit-trigger-audit.js").default>} */
  notificationTypeAuditTriggerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeAuditTriggerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "notification_type_audit_trigger_audits",
        model: this,
        modelName: "NotificationTypeAuditTrigger::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-type-audit-trigger-audit.js").default>>} */
  loadNotificationTypeAuditTriggerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeAuditTriggerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "notification_type_audit_trigger_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-type-audit.js").default>} */
  notificationTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "notification_type_audits",
        model: this,
        modelName: "NotificationType::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-type-audit.js").default>>} */
  loadNotificationTypeAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("NotificationTypeAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "notification_type_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./page-content-audit.js").default>} */
  pageContentAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PageContentAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "page_content_audits",
        model: this,
        modelName: "PageContent::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./page-content-audit.js").default>>} */
  loadPageContentAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PageContentAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "page_content_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./page-view-audit.js").default>} */
  pageViewAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PageViewAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "page_view_audits",
        model: this,
        modelName: "PageView::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./page-view-audit.js").default>>} */
  loadPageViewAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PageViewAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "page_view_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./payment-method-audit.js").default>} */
  paymentMethodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PaymentMethodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "payment_method_audits",
        model: this,
        modelName: "PaymentMethod::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./payment-method-audit.js").default>>} */
  loadPaymentMethodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PaymentMethodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "payment_method_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-audit.js").default>} */
  planAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "plan_audits",
        model: this,
        modelName: "Plan::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-audit.js").default>>} */
  loadPlanAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "plan_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-resource-audit.js").default>} */
  planResourceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "plan_resource_audits",
        model: this,
        modelName: "PlanResource::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-resource-audit.js").default>>} */
  loadPlanResourceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "plan_resource_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-resource-period-audit.js").default>} */
  planResourcePeriodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "plan_resource_period_audits",
        model: this,
        modelName: "PlanResourcePeriod::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-resource-period-audit.js").default>>} */
  loadPlanResourcePeriodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "plan_resource_period_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-resource-period-price-audit.js").default>} */
  planResourcePeriodPriceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodPriceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "plan_resource_period_price_audits",
        model: this,
        modelName: "PlanResourcePeriodPrice::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-resource-period-price-audit.js").default>>} */
  loadPlanResourcePeriodPriceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodPriceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "plan_resource_period_price_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./role-audit.js").default>} */
  roleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("RoleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "role_audits",
        model: this,
        modelName: "Role::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./role-audit.js").default>>} */
  loadRoleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("RoleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "role_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-audit.js").default>} */
  schoolAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_audits",
        model: this,
        modelName: "School::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-audit.js").default>>} */
  loadSchoolAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-audit.js").default>} */
  schoolClassAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_audits",
        model: this,
        modelName: "SchoolClass::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-audit.js").default>>} */
  loadSchoolClassAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-check-in-audit.js").default>} */
  schoolClassCheckInAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCheckInAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_check_in_audits",
        model: this,
        modelName: "SchoolClassCheckIn::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-check-in-audit.js").default>>} */
  loadSchoolClassCheckInAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCheckInAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_check_in_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-check-in-event-audit.js").default>} */
  schoolClassCheckInEventAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCheckInEventAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_check_in_event_audits",
        model: this,
        modelName: "SchoolClassCheckInEvent::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-check-in-event-audit.js").default>>} */
  loadSchoolClassCheckInEventAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCheckInEventAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_check_in_event_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-content-piece-audit.js").default>} */
  schoolClassContentPieceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassContentPieceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_content_piece_audits",
        model: this,
        modelName: "SchoolClassContentPiece::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-content-piece-audit.js").default>>} */
  loadSchoolClassContentPieceAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassContentPieceAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_content_piece_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-course-audit.js").default>} */
  schoolClassCourseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_course_audits",
        model: this,
        modelName: "SchoolClassCourse::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course-audit.js").default>>} */
  loadSchoolClassCourseAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCourseAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_course_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-course-module-audit.js").default>} */
  schoolClassCourseModuleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCourseModuleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_course_module_audits",
        model: this,
        modelName: "SchoolClassCourseModule::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course-module-audit.js").default>>} */
  loadSchoolClassCourseModuleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassCourseModuleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_course_module_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-group-audit.js").default>} */
  schoolClassGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_group_audits",
        model: this,
        modelName: "SchoolClassGroup::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-group-audit.js").default>>} */
  loadSchoolClassGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_group_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-group-class-step-audit.js").default>} */
  schoolClassGroupClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassGroupClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_group_class_step_audits",
        model: this,
        modelName: "SchoolClassGroupClassStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-group-class-step-audit.js").default>>} */
  loadSchoolClassGroupClassStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassGroupClassStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_group_class_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-invitation-audit.js").default>} */
  schoolClassInvitationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassInvitationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_invitation_audits",
        model: this,
        modelName: "SchoolClassInvitation::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-invitation-audit.js").default>>} */
  loadSchoolClassInvitationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolClassInvitationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_invitation_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-contact-request-audit.js").default>} */
  schoolContactRequestAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolContactRequestAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_contact_request_audits",
        model: this,
        modelName: "SchoolContactRequest::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-contact-request-audit.js").default>>} */
  loadSchoolContactRequestAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SchoolContactRequestAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_contact_request_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./score-factor-audit.js").default>} */
  scoreFactorAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "score_factor_audits",
        model: this,
        modelName: "ScoreFactor::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./score-factor-audit.js").default>>} */
  loadScoreFactorAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "score_factor_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./score-factor-group-audit.js").default>} */
  scoreFactorGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "score_factor_group_audits",
        model: this,
        modelName: "ScoreFactorGroup::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./score-factor-group-audit.js").default>>} */
  loadScoreFactorGroupAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorGroupAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "score_factor_group_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./score-factor-group-score-factor-audit.js").default>} */
  scoreFactorGroupScoreFactorAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorGroupScoreFactorAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "score_factor_group_score_factor_audits",
        model: this,
        modelName: "ScoreFactorGroupScoreFactor::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./score-factor-group-score-factor-audit.js").default>>} */
  loadScoreFactorGroupScoreFactorAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ScoreFactorGroupScoreFactorAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "score_factor_group_score_factor_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./styling-audit.js").default>} */
  stylingAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("StylingAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "styling_audits",
        model: this,
        modelName: "Styling::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./styling-audit.js").default>>} */
  loadStylingAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("StylingAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "styling_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription-audit.js").default>} */
  subscriptionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SubscriptionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "subscription_audits",
        model: this,
        modelName: "Subscription::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./subscription-audit.js").default>>} */
  loadSubscriptionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SubscriptionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "subscription_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription-period-audit.js").default>} */
  subscriptionPeriodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SubscriptionPeriodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "subscription_period_audits",
        model: this,
        modelName: "SubscriptionPeriod::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./subscription-period-audit.js").default>>} */
  loadSubscriptionPeriodAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SubscriptionPeriodAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "subscription_period_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-audit.js").default>} */
  surveyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "survey_audits",
        model: this,
        modelName: "Survey::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-audit.js").default>>} */
  loadSurveyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "survey_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-audit.js").default>} */
  surveyStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "survey_step_audits",
        model: this,
        modelName: "SurveyStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-audit.js").default>>} */
  loadSurveyStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "survey_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-element-audit.js").default>} */
  surveyStepElementAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "survey_step_element_audits",
        model: this,
        modelName: "SurveyStepElement::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element-audit.js").default>>} */
  loadSurveyStepElementAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "survey_step_element_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-element-option-audit.js").default>} */
  surveyStepElementOptionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementOptionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "survey_step_element_option_audits",
        model: this,
        modelName: "SurveyStepElementOption::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element-option-audit.js").default>>} */
  loadSurveyStepElementOptionAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementOptionAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "survey_step_element_option_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-element-option-score-audit.js").default>} */
  surveyStepElementOptionScoreAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementOptionScoreAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "survey_step_element_option_score_audits",
        model: this,
        modelName: "SurveyStepElementOptionScore::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element-option-score-audit.js").default>>} */
  loadSurveyStepElementOptionScoreAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("SurveyStepElementOptionScoreAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "survey_step_element_option_score_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-audit.js").default>} */
  teamAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_audits",
        model: this,
        modelName: "Team::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-audit.js").default>>} */
  loadTeamAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-audit.js").default>} */
  teamSurveyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_audits",
        model: this,
        modelName: "TeamSurvey::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-audit.js").default>>} */
  loadTeamSurveyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step-audit.js").default>} */
  teamSurveyStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_step_audits",
        model: this,
        modelName: "TeamSurveyStep::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-audit.js").default>>} */
  loadTeamSurveyStepAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_step_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step-element-answer-audit.js").default>} */
  teamSurveyStepElementAnswerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAnswerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_step_element_answer_audits",
        model: this,
        modelName: "TeamSurveyStepElementAnswer::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-element-answer-audit.js").default>>} */
  loadTeamSurveyStepElementAnswerAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAnswerAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_step_element_answer_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step-element-audit.js").default>} */
  teamSurveyStepElementAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_step_element_audits",
        model: this,
        modelName: "TeamSurveyStepElement::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-element-audit.js").default>>} */
  loadTeamSurveyStepElementAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_step_element_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-user-audit.js").default>} */
  teamUserAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamUserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_user_audits",
        model: this,
        modelName: "TeamUser::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-user-audit.js").default>>} */
  loadTeamUserAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamUserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_user_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./text-key-audit.js").default>} */
  textKeyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextKeyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "text_key_audits",
        model: this,
        modelName: "TextKey::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./text-key-audit.js").default>>} */
  loadTextKeyAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextKeyAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "text_key_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./text-value-audit.js").default>} */
  textValueAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextValueAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "text_value_audits",
        model: this,
        modelName: "TextValue::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./text-value-audit.js").default>>} */
  loadTextValueAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextValueAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "text_value_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./translation-audit.js").default>} */
  translationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TranslationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "translation_audits",
        model: this,
        modelName: "Translation::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./translation-audit.js").default>>} */
  loadTranslationAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TranslationAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "translation_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./trix-file-audit.js").default>} */
  trixFileAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TrixFileAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "trix_file_audits",
        model: this,
        modelName: "TrixFile::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./trix-file-audit.js").default>>} */
  loadTrixFileAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TrixFileAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "trix_file_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-audit.js").default>} */
  userAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "user_audits",
        model: this,
        modelName: "User::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-audit.js").default>>} */
  loadUserAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "user_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-role-audit.js").default>} */
  userRoleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserRoleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "user_role_audits",
        model: this,
        modelName: "UserRole::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-role-audit.js").default>>} */
  loadUserRoleAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserRoleAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "user_role_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./vat-number-audit.js").default>} */
  vatNumberAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("VatNumberAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "vat_number_audits",
        model: this,
        modelName: "VatNumber::Audit",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./vat-number-audit.js").default>>} */
  loadVatNumberAudits() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("VatNumberAudit")

    const ransack = {}

    ransack["audit_auditable_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "vat_number_audits",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default AuditAuditableType
